export default __webpack_public_path__ + "static/media/character_key_visual.4d27c9fe.png";